const messages: Record<string, string> = {
	'loader.loading': 'Loading data ...',
	'loader.error': 'Your process could not be loaded. Please try again later...',
	'connectionError.title': 'Connection error',
	'connectionError.description': 'Connection error. Please upload picture again.',
	'mainError.tryAgain': 'Try again',
	'landing.headline.policyCheck': 'Welcome',
	'landing.paragraph': 'You are just two steps away from finishing the digital vehicle inspection',
	'landing.stepDescription.fourAdditionalPictures': 'Take the required pictures',
	'landing.stepDescription.fourDiagonalPerspectives': 'Take the required pictures',
	'landing.stepDescription.feedback': 'Let us know how it went',
	'landing.termsAndConditionsLinkDescription':
		'By pressing "Start" you are accepting our <tclink>terms and conditions</tclink>.',
	'landing.termsAndConditionsLink':
		'By pressing "Start" you are accepting our terms and conditions.',
	'button.start': 'Start',
	'landing.aboutPolicyCheck': 'Back',
	'landing.additional-informations-section.title':
		'For a successful pre-damage inspection, please ensure that ...',
	'landing.additional-informations-section.text':
		'<ul><li>your vehicle is clean and dry.</li><li>you carry out the inspection in daylight or in a well-lit garage.</li><li>the entire vehicle is clearly visible in the photos (ideally in landscape format).</li></ul>',
	'landing.additional-informations-section.text.motorbike': ' ',
	'chooseLang.headline': 'Choose your preferred language',
	'button.close': 'Close',
	'blockedByDevice.headline': 'PolicyCheck does not support desktop browsers',
	'blockedByDevice.description':
		'PolicyCheck is using a desktop browser.<br>The PolicyCheck platform performs documenting cases using mobile devices.<br>To continue, please run the PolicyCheck link on a mobile device',
	'tutorialModal.headline.first.policyCheck': 'What is behind PolicyCheck?',

	'vehicleImages.overviewPhotos': 'Vehicle overview',
	'vehicleImages.overviewPhotos.subtitle': 'Photograph vehicle',
	'vehicleImages.description':
		'Take photos of the entire vehicle from all angles (ideally in landscape format). The number plate should be clearly visible in all photos. Please refer to the sample photos for guidance.',
	'vehicleImages.description.motorbike':
		'Photograph vehicle diagonally front left and right, rear left and right. The license plate must be visible in all rear pictures.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Front left diagonal',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Rear left diagonal',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Rear right diagonal',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Front right diagonal',
	'button.next': 'Next',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Photo example',
	'imageRecognitionMismatchModal.headline':
		'The photo taken does <b>not</b> meet the necessary <b>requirements</b>. Please try again. If you continue with this photo, we cannot guarantee a complete pre-damage inspection, and you will receive your insurance policy with the agreed <b>increased</b> deductible <b>(€1,200)</b> in the next few days.',
	'button.continue': 'CONTINUE',
	'button.backchangeImage': 'RETAKE THE PHOTO',
	'completeVehicleImagesModal.headline': 'Missing photos',
	'completeVehicleImagesModal.description': 'Please add the following photographs:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Front left diagonal',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Rear left diagonal',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Front right diagonal',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Rear right diagonal',
	'vehicleImages.leftFrontOverview': 'Front left diagonal',
	'vehicleImages.leftRearOverview': 'Rear left diagonal',
	'vehicleImages.rightRearOverview': 'Rear right diagonal',
	'vehicleImages.rightFrontOverview': 'Front right diagonal',
	'button.changeImage': 'RETAKE THE PHOTO',
	'button.deleteImage': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Front left diagonal example photo',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Rear left diagonal example photo',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Rear right diagonal example photo',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Front right diagonal example photo',
	'button.ok': 'OK',
	'fourPerspectivesExampleModal.button.close': 'OK',
	'mistmachModal.enteredMileage': 'Entered mileage',
	'button.prev': 'Back',

	'fourAdditionalPictures.title': 'Additional information',
	'fourAdditionalPictures.overallDashboard.title': 'Dashboard',
	'fourAdditionalPictures.overallDashboard.description':
		'Take a photo showing the entire dashboard of the vehicle. The best way to do this is to take the photo in landscape format from the back seat.',
	'fourAdditionalPictures.mileage.title': 'Mileage',
	'dashboardMileage.dashboard.paragraph':
		'Take a photo of the vehicle odometer with the current mileage visible. If you have a digital display, please turn it on.',
	'dashboardMileage.paragraph.first': 'Enter the current mileage.',
	'dashboardMileage.placeholder': 'Current mileage',
	'feedback.comment.placeholder': 'Add your comment',
	'fourAdditionalPictures.windshield.title': 'Windshield',
	'fourAdditionalPictures.windshield.description':
		'Take a detailed photo of the entire windshield of the vehicle.',
	'fourAdditionalPictures.vin.title': 'VIN number',
	'fourAdditionalPictures.vin.description':
		"Take a photo of the Vehicle Identification Number“(VIN). This is a 17-digit combination of numbers and letters. The VIN can be found on the door frame, in the lower right-hand corner of the windshield or in the engine compartment. You can find more details about the location of the VIN for your vehicle in the owner's manual.",
	'overallDashboardImage.title': 'Dashboard',
	'dashboardMileage.dashboard.title': 'Mileage',
	'windshieldImage.title': 'Windshield',
	'vinPicture.title': 'VIN number',
	'completeFourAdditionalPicturesModal.headline': 'Missing photos',
	'completeFourAdditionalPicturesModal.description': 'Please include the following photographs:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Dashboard',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Mileage',
	'completeDashboardMileageModal.hasValidMileage': 'Mileage',
	'completeFourAdditionalPicturesModal.hasVINImage': 'VIN number',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Windshield',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Dashboard example photo',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Mileage example photo',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Windshield example photo',
	'fourAdditionalPictures.vin.exampleModalTitle': 'VIN number example photo',
	'fourAdditionalPicturesExampleModal.button.close': 'OK',
	'fourPicturesExampleModal.button.close': 'OK',

	'fourAdditionalDocuments.title': ' ',
	'fourAdditionalDocuments.RegistrationDocument.title': ' ',
	'fourAdditionalDocuments.RegistrationDocument.description': ' ',
	'image.locked.RegistrationDocument': ' ',
	'fourAdditionalDocuments.RegistrationDocumentInside.title': ' ',
	'fourAdditionalDocuments.RegistrationDocumentInside.description': ' ',
	'image.locked.RegistrationDocumentInside': ' ',
	'fourAdditionalDocuments.DniInside.title': ' ',
	'fourAdditionalDocuments.DniInside.description': ' ',
	'image.locked.DniInside': ' ',
	'fourAdditionalDocuments.DniOutside.title': ' ',
	'fourAdditionalDocuments.DniOutside.description': ' ',
	'image.locked.DniOutside': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.title': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.description': ' ',
	'image.locked.VehicleDatasheetInside': ' ',
	'fourAdditionalDocuments.VehicleDatasheetInside.title': ' ',
	'fourAdditionalDocuments.VehicleDatasheetInside.description': ' ',
	'image.locked.VehicleDatasheetOutside': ' ',
	'fourAdditionalDocuments.DriverLicenseInside.title': ' ',
	'fourAdditionalDocuments.DriverLicenseInside.description': ' ',
	'image.locked.DriverLicenseInside': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.title': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.description': ' ',
	'image.locked.DriverLicenseOutside': ' ',
	'completeFourAdditionalDocumentsModal.headline': ' ',
	'completeFourAdditionalDocumentsModal.description': ' ',
	'fourAdditionalDocuments.RegistrationDocument.headline': ' ',
	'fourAdditionalDocuments.RegistrationDocumentInside.headline': ' ',
	'fourAdditionalDocuments.DniInside.headline': ' ',
	'fourAdditionalDocuments.DniOutside.headline': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.headline': ' ',
	'fourAdditionalDocuments.VehicleDatasheetInside.headline': ' ',
	'fourAdditionalDocuments.DriverLicenseInside.headline': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.headline': ' ',
	'fourAdditionalDocuments.RegistrationDocument.exampleModalTitle': ' ',
	'fourAdditionalDocuments.RegistrationDocumentInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DniInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DniOutside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.VehicleDatasheetInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DriverLicenseInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.exampleModalTitle': ' ',
	'overallDashboardImage.headline': 'Dashboard',
	'vinPicture.headline': 'VIN number',
	'windshieldImage.headline': 'Windshield',

	'feedback.headline.policyCheck': 'All pictures were received successfully!',
	'feedback.description': ' ',
	'feedback.rating.policyCheck': 'How would you rate your experience?',
	'feedback.yourOpinion': 'Any comments? Let us know!',
	'feedback.button.send': 'Submit',
	'waitForAudit.thankYou': 'Thank you for feedback!',
	'waitForAudit.description.damageFound': ' ',
	'thanks.headline.first': 'Thank you for feedback!',
	'thanks.paragraph.first': ' ',

	'timeout.headline.first': 'The link to the application is no longer active!',
	'timeout.paragraph.first': ' ',
	'timeout.bottom': ' ',

	'invalidFile.size.title': 'Incorrect image size',
	'invalidFile.size.description': 'The image size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .png, .heic, .heif and .bmp',
};

export default messages;
